import {
  AppAction,
  Application
} from '../apis/eols-app-link/eols-app-link.constants';
import { AssignmentType } from '../apis/eols-assessment-service/eols-assessment-service.dtos';
import { AppLinkRedirectErrorMessage } from '../pages/app-link-redirect/app-link-redirect.constants';

export enum AnalyticsAction {
  LOGIN_LAUNCH = 'LOGIN_LAUNCH',
  APP_LINK_LAUNCH = 'APP_LINK_LAUNCH',
  APP_LINK_ERROR = 'APP_LINK_ERROR',
  APP_LINK_OUT = 'APP_LINK_OUT',
  API_ERROR = 'API_ERROR',
  COURSEWARE_MASTERY_RESET = 'COURSEWARE_MASTERY_RESET',
  ASSIGNMENT_EDITOR_POST_HANDLED = 'ASSIGNMENT_EDITOR_POST_HANDLED',
  EAQ_REPORT_CONTENT_ERROR_CLICKED = 'EAQ_REPORT_CONTENT_ERROR_CLICKED',
  PLEASE_TRY_ANOTHER_KEYWORD = 'PLEASE_TRY_ANOTHER_KEYWORD',
  VIEW_ALL_ATTEMPTS_CLICK = 'VIEW_ALL_ATTEMPTS_CLICK',
  VIEW_SUBMISSION_CLICK = 'VIEW_SUBMISSION_CLICK',
  STUDENT_SIMULATION_PERFORMANCE_MODAL_OPENED = 'STUDENT_SIMULATION_PERFORMANCE_MODAL_OPENED'
}

export type AnalyticsActionProps = {
  action: AnalyticsAction.LOGIN_LAUNCH;
  props: null;
} | {
  action: AnalyticsAction.API_ERROR;
  props: {
    status: string;
    action: string;
    url: string;
    method: string;
  };
} | {
  action: AnalyticsAction.APP_LINK_ERROR;
  props: {
    type: AppLinkRedirectErrorMessage;
    status: string;
    url: string;
    method: string;
  };
} | {
  action: AnalyticsAction.APP_LINK_OUT
  | AnalyticsAction.APP_LINK_LAUNCH;
  props: {
    linkType: AppAction;
    srcApp: Application;
    targetApp: Application;
  };
} | {
  action: AnalyticsAction.VIEW_ALL_ATTEMPTS_CLICK;
  props: {
    assignmentType: AssignmentType;
  };
} | {
  action: AnalyticsAction.STUDENT_SIMULATION_PERFORMANCE_MODAL_OPENED;
  props: {};
} | {
  action: AnalyticsAction.COURSEWARE_MASTERY_RESET;
  props: {
    resetIsbn: string;
    studentUserId: number;
  };
} | {
  action: AnalyticsAction.ASSIGNMENT_EDITOR_POST_HANDLED;
  props: {
    ref: string;
    assignmentIds: number[];
  };
} | {
  action: AnalyticsAction.EAQ_REPORT_CONTENT_ERROR_CLICKED;
  props: {
    questionVtwId: string;
    isbn: string;
    ref: string;
  };
} | {
  action: AnalyticsAction.PLEASE_TRY_ANOTHER_KEYWORD;
  props: {
    search: string;
    isbn: string;
  };
} | {
  action: AnalyticsAction.VIEW_ALL_ATTEMPTS_CLICK;
  props: {
    assignmentType: AssignmentType;
  };
} | {
  action: AnalyticsAction.VIEW_SUBMISSION_CLICK;
  props: {
    assignmentType: AssignmentType;
  };
} | {
  action: AnalyticsAction.STUDENT_SIMULATION_PERFORMANCE_MODAL_OPENED;
  props: {};
}
